(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/assets/javascripts/views/bets.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/assets/javascripts/views/bets.js');


'use strict';

svs.numbergames.prolongation.views.Bets = Marionette.View.extend({
  className: 'prolongation-bets',
  regions: {
    betDetailsRegion: '.prolongation-bet-region',
    jokerDetailsRegion: '.prolongation-joker-region'
  },
  ui: {
    betsContent: '.js-prolongation-bets-content'
  },
  template(data) {
    return svs.numbergames.prolongation.templates.bets(data);
  },
  onRender() {
    const isKeno = svs.numbergames.productMapping.isKeno(this.model.get('productId'));
    this.showChildView('betDetailsRegion', {
      collection: this.model.get('bet').get('boards'),
      className: 'prolongation-bet-details',
      template(_ref) {
        let {
          items
        } = _ref;
        return svs.numbergames.ball_row_helper.getBallRowsEl({
          items,
          ballRowsOptions: {
            size: isKeno ? 100 : 300
          }
        });
      }
    });
    if (this.model.get('hasJoker')) {
      this.showChildView('jokerDetailsRegion', {
        model: this.model.get('jokerBet').get('boards').first(),
        className: 'prolongation-bet-details',
        template(_ref2) {
          let {
            numbers
          } = _ref2;
          return new svs.tur.ball.row.Joker({
            numbers,
            description: new svs.tur.ball.row.extensions.Description({
              title: 'Joker'
            }),
            size: 300
          }).render();
        }
      });
    }
  },
  onBeforeAttach() {
    gsap.set(this.getUI('betsContent'), {
      autoAlpha: 0
    });
    gsap.set(this.$el, {
      height: 0
    });
  },
  onAttach() {
    gsap.to(this.$el, {
      height: 'auto',
      duration: 0.3,
      delay: 0.3
    });
    gsap.to(this.getUI('betsContent'), {
      autoAlpha: 1,
      duration: 0.3,
      delay: 0.6,
      callbackScope: this,
      onComplete() {
        this.triggerMethod('detailsOpened', this);
      }
    });
  },
  destroy() {
    this.triggerMethod('detailsClosed', this);
    gsap.to(this.getUI('betsContent'), {
      autoAlpha: 0,
      duration: 0.15
    });
    gsap.to(this.$el, {
      height: 0,
      duration: 0.2,
      delay: 0.1,
      callbackScope: this,
      onComplete() {
        this.constructor.__super__.destroy.apply(this);
      }
    });
  }
});

 })(window);